export default function About() {
  return (
    <section id="about" className="commodities">
      <div className="container">
        <div className="section-title">
          <h2>About</h2>
          <p>
            Learn more <span>about us</span>
          </p>
        </div>
        <div className="row">
          <div className="col-lg-4 d-none d-lg-inline">
            <img src="assets/img/about.png" className="img-fluid" alt="Cotton Cover" style={{height: "100%"}}/>
          </div>
          <div className="col-lg-8 pt-4 pt-lg-0 content">
            <div className="commodities-item">
              <p>
                <em>
                  Fund Marketing International (FMI) is a commodity brokerage firm that focuses on the import/export of cotton, sugar,
                  and related commodities. FMI provides unique in-depth analytical research and market reports
                  prepared with effective data, collected by crop surveys and market sources.
                  FMI is a Karachi-based firm that operates within local and international markets.
                </em>
              </p>
            </div>
            {/* <hr style={{border: "solid 1px #413D39"}}/> */}
            <div className="commodities-item">
              <div className="row">
                <div className="col-lg-3">
                  <h4 style={{color: "#FFB03B", fontWeight: "bold"}}>
                    Values
                  </h4>                  
                  <ul>
                    <li>
                      <i className="icofont-rounded-right"></i>
                      Integrity
                    </li>
                    <li>
                      <i className="icofont-rounded-right"></i>
                      Reliability
                    </li>
                    <li>
                      <i className="icofont-rounded-right"></i>
                      Impartiality
                    </li>
                  </ul>
                </div>
                <div className="col-lg-9">
                  <h4 style={{color: "#FFB03B", fontWeight: "bold"}}>
                    Associate Companies
                  </h4>
                  <ul>
                    <li>
                      <i className="icofont-rounded-right"></i>
                      <a href="https://par.com.pk/" target="_blank" rel="noreferrer">
                        Pakistan Agriculture Research
                      </a> – B2B Agri Research Consultancy
                    </li>
                    <li>
                      <i className="icofont-rounded-right"></i>
                      <a href="https://zaraimandi.com/" target="_blank" rel="noreferrer">
                        Zarai Mandi
                      </a> – B2C Price Discovery WhatsApp Service
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="commodities-item">
              <div className="row">
                <div className="col-lg-3">
                  <h4 style={{color: "#FFB03B", fontWeight: "bold"}}>
                    Team Strength
                  </h4>                  
                  <ul>
                    <li>
                      <i className="icofont-rounded-right"></i>
                       20+ employees
                    </li>
                  </ul>
                </div>
                <div className="col-lg-9">
                  <h4 style={{color: "#FFB03B", fontWeight: "bold"}}>
                    Mission
                  </h4>
                  <ul>
                    <li>
                      <i className="icofont-rounded-right"></i>
                      To meet the diverse needs of our partners globally in soft commodities sourcing.
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="commodities-item">
              <h4 style={{color: "#FFB03B", fontWeight: "bold"}}>
                Core Strengths
              </h4>                  
              <ul>
                <li>
                  <i className="icofont-rounded-right"></i>
                  Import Cotton from USA, Brazil, Egypt, West Africa and Australia
                </li>
                <li>
                  <i className="icofont-rounded-right"></i>
                  Excellent relations with Ginning Factories across Pakistan
                </li>
                <li>
                  <i className="icofont-rounded-right"></i>
                  Qualified Cotton Classer & Cotton Selector
                </li>
                <li>
                  <i className="icofont-rounded-right"></i>
                  Relations with the Karachi Cotton Association (KCA)
                </li>
                <li>
                  <i className="icofont-rounded-right"></i>
                  FMI was set up with the guidance and mentorship of the late Yousuf Tayyab Ali,
                  a cotton expert with 60 years of experience who set up over 100 ginning factories in Pakistan
                </li>
                <li>
                  <i className="icofont-rounded-right"></i>
                  Trained Agronomists for crop surveys and farmer crop advisory
                </li>
                <li>
                  <i className="icofont-rounded-right"></i>
                  Export Markets in China, Indonesia, Bangladesh, Afghanistan, Taiwan and Turkey
                </li>
              </ul>
            </div>
            <div className="commodities-item">
              <h4 style={{color: "#FFB03B", fontWeight: "bold"}}>
                Strategic Intent
              </h4>                  
              <ul>
                <li>
                  <i className="icofont-rounded-right"></i>
                  Develop long-lasting relationships with each of our clients
                </li>
                <li>
                  <i className="icofont-rounded-right"></i>
                  Reach and commitment for a global mission
                </li>
                <li>
                  <i className="icofont-rounded-right"></i>
                  Staffed with professionals who combine fundamental and
                  econometric research to keep its clients ahead of the market for commodities
                </li>
                <li>
                  <i className="icofont-rounded-right"></i>
                  Focus on cost management
                </li>
                <li>
                  <i className="icofont-rounded-right"></i>
                  Move downstream in the value chain
                </li>
                <li>
                  <i className="icofont-rounded-right"></i>
                  Build a balanced earning portfolio
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}
